import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import iconProfileRed from "@/assets/icons/profile-circle.svg";
import AppLink from "@/components/atoms/AppLink";
import AppButton from "@/components/sitehub-ui/atoms/AppButton";
import { AppLandingTemplate } from "@/components/sitehub-ui/templates/AppLandingHorizontalTemplate";
import { PAGE_URL } from "@/data_source/constants";
import { useAppNavigator } from "@/router/redirections";
import { classes } from "@/utils/css";

import styles from "./AppUserInactive.module.css";

function UserInactive(props: { email: string }) {
  const { t } = useTranslation();
  const navigate = useAppNavigator();
  return (
    <Grid
      container
      direction="column"
      padding="46px 0px 72px 0px"
      alignItems="center"
      flexWrap="nowrap"
      maxHeight="326px"
      height="326px"
    >
      <img src={iconProfileRed} alt="success" />
      <Typography
        className={classes(styles.label, styles.dark, styles.big)}
        margin="20px 0px 4px 0px"
      >
        {t("User Deactivated")}
      </Typography>
      <Typography
        className={classes(styles.label)}
        textAlign="center"
        marginBottom="18px"
        maxWidth="397px"
      >
        {t("Hi")} <strong>{props.email ?? ""}</strong>{" "}
        {t("templateUserInactive")}
      </Typography>
      <AppButton
        disabled={false}
        label={t("Reactivate user")}
        style={{ paddingLeft: "32px", paddingRight: "32px" }}
        onClick={() => {
          navigate(PAGE_URL.PASSWORD_RECOVERY.replace(":email", props.email));
        }}
      />
      <AppLink
        className={classes(styles.link, styles.capitalize)}
        style={{ marginTop: "18px" }}
        href={PAGE_URL.SIGN_IN}
      >
        {t("Login")}
      </AppLink>
    </Grid>
  );
}
type Props = {
  email: string;
};

export function AppUserInactiveView(props: Props) {
  const { t } = useTranslation();

  return (
    <AppLandingTemplate title={t("Session blocked")}>
      <UserInactive email={props.email} />
    </AppLandingTemplate>
  );
}
